import Skeleton from "@mui/material/Skeleton";
import { Container, TextField } from "@mui/material";
import React, { useState, useEffect } from "react";
import { Button } from "@mui/material";
import "./CSS/menu2.css";
import { ThemeProvider } from "@mui/material/styles";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import SearchIcon from "@mui/icons-material/Search";
import Navbar from "../Components/Navbar";
import MenuFoodCard from "../Components/MenuFoodCard";
import FooterComp from "../Components/FooterComp";
import { theme } from "../Components/Theme";
import NavbarMobile from "../Components/NavbarMobile";

/*eslint-disable*/
function Menu() {
  const [dishes, setDishes] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState();
  const [dishType, setDishType] = useState();
  const [isLoading, setIsLoading] = useState(true);
  // useEffect(() => {
  //   fetch("/menu/get")
  //     .then((res) => res.json())
  //     .then((data) => {
  //       const dish = data.food_item;
  //       setDishes(dish);
  //     })
  //     .catch((err) => console.log(err));
  // }, []);

  useEffect(() => {
    const fetchDishes = async () => {
      const response = await fetch("https://dummyjson.com/recipes");
      const data = await response.json();
      setDishes(data.recipes);
    };
    fetchDishes();
    setTimeout(() => setIsLoading(false), 1000);
  }, []);

  const handleDishType = async (dishType) => {
    if (dishType === selectedCategory) {
      setSelectedCategory("");
      setDishType("");
    } else {
      setSelectedCategory(dishType);
      setDishType(dishType);
    }
  };

  const filteredDishes = selectedCategory
    ? dishes.filter((dish) => dish.cuisine === selectedCategory)
    : dishes;

  return (
    <>
      <div className="desktop-content">
        <Navbar></Navbar>
      </div>
      <div className="mobile-content">
        <NavbarMobile />
      </div>
      <div className="menu">
        <ThemeProvider theme={theme}>
          <Grid2 container spacing={1}>
            <Grid2 xs={1} md={4} lg={2} xl={3}>
              <Container>
                <div className="menu2">
                  <div className="desktop-content">
                    <TextField
                      id="outlined-basic"
                      label="Search"
                      variant="outlined"
                      size="small"
                    />
                    <Button>
                      <SearchIcon />
                    </Button>
                  </div>
                  <Button
                    variant="contained"
                    color={
                      selectedCategory === "starters" ? "primary" : "secondary"
                    }
                    className="button"
                    size="small"
                    onClick={() => handleDishType("starters")}
                    sx={{
                      padding: "10px",
                      borderRadius: "10px",
                      margin: "5px",
                    }}
                  >
                    Breakfast
                  </Button>
                  <Button
                    variant="contained"
                    color={
                      selectedCategory === "MainCourse"
                        ? "primary"
                        : "secondary"
                    }
                    className="button"
                    size="small"
                    onClick={() => handleDishType("MainCourse")}
                    sx={{
                      padding: "10px",
                      borderRadius: "10px",
                      margin: "5px",
                    }}
                  >
                    Main Course
                  </Button>
                  <Button
                    variant="contained"
                    color={
                      selectedCategory === "desert" ? "primary" : "secondary"
                    }
                    className="button"
                    size="small"
                    onClick={() => handleDishType("desert")}
                    sx={{
                      padding: "10px",
                      borderRadius: "10px",
                      margin: "5px",
                    }}
                  >
                    Deserts
                  </Button>
                  <Button
                    variant="contained"
                    color={
                      selectedCategory === "drinks" ? "primary" : "secondary"
                    }
                    className="button"
                    size="small"
                    onClick={() => handleDishType("drinks")}
                    sx={{
                      padding: "10px",
                      borderRadius: "10px",
                      margin: "5px",
                    }}
                  >
                    Drinks
                  </Button>
                </div>
              </Container>
            </Grid2>

            <Grid2 xs={12} md={8} lg={8} xl={8}>
              <Container>
                <Grid2 container columnSpacing={6} rowSpacing={3}>
                  {isLoading
                    ? Array.from(new Array(4)).map((_, index) => (
                        <Grid2 item xs={12} md={6} lg={6} xl={6} key={index}>
                          <Skeleton
                            variant="rectangular"
                            height={220}
                            width={400}
                          />
                        </Grid2>
                      ))
                    : filteredDishes.map((items) => (
                        <Grid2 item xs={12} md={6} lg={6} xl={6}>
                          <MenuFoodCard foodItems={items} />
                        </Grid2>
                      ))}
                </Grid2>
              </Container>
            </Grid2>
          </Grid2>
        </ThemeProvider>
      </div>
      <FooterComp margin="800px" />
    </>
  );
}

export default Menu;
